<template>
  <div class="interest">
    <img :src="url" />
  </div>
</template>

<script>
  export default {
    name: 'interest',
    data () {
      return {
        url:'',
      }
    },
    created(){
      let  { query:{ url } } = this.$route;
      this.url = url;
    },
    mounted(){
    },
    methods: {

    },
  }
</script>
 


// WEBPACK FOOTER //
// src/pages/interest.vue